export enum RafflePageTabIds {
	MAIN_PAGE = 0,
	PURCHASE_ENTRY_PAGE = 1,
	USER_ENTRIES_PAGE = 2,
}
